<div class="loading-overlay">
    <div class="app-splash-screen">
        <div class="app-splash-screen-content">
            <!--<span class="text-large font-weight-bolder">OrgaCard Logo</span>-->
            <span class="text-large font-weight-bolder">
                <img
                    src="assets/logo_orgacard_mobile.svg"
                    class="d-block"
                    alt
                />
                <!--                {{ counter$ | async }}-->
            </span>
        </div>
    </div>
</div>
